var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocs = function SvgDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M21 15.016c-.046-.992-.723-1.016-1.643-1.016-1.416 0-1.651.338-1.651 1.667v1.666c0 1.329.235 1.667 1.651 1.667.92 0 1.597-.024 1.643-1.016M10.295 16.5c0 1.38-1.106 2.5-2.47 2.5-.309 0-.463 0-.577-.067-.275-.16-.247-.485-.247-.766v-3.334c0-.281-.028-.606.247-.766.114-.067.268-.067.576-.067 1.365 0 2.47 1.12 2.47 2.5ZM14 19c-.776 0-1.165 0-1.406-.244s-.241-.637-.241-1.423v-1.666c0-.786 0-1.179.241-1.423S13.224 14 14 14s1.165 0 1.406.244.241.637.241 1.423v1.666c0 .786 0 1.179-.241 1.423S14.776 19 14 19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M19 11c0-1 0-1.57-.152-1.937s-.441-.657-1.02-1.235l-4.736-4.736c-.499-.499-.748-.748-1.058-.896a2 2 0 0 0-.197-.082C11.514 2 11.161 2 10.456 2c-3.245 0-4.868 0-5.967.886a4 4 0 0 0-.603.603C3 4.59 3 6.211 3 9.456V14c0 3.771 0 5.657 1.172 6.828S7.229 22 11 22h8M12 2.5V3c0 2.828 0 4.243.879 5.121C13.757 9 15.172 9 18 9h.5"
  })));
};
export default SvgDocs;